import { makeStyles } from "@mui/styles";
import { Theme } from "tm-controls";

export const BiometricAuthenticationUnavailableDialogStyles = makeStyles((theme: Theme) => ({
    dialogButton: {
        lineHeight: "20px !important"
    }
}))
